module.exports = __webpack_public_path__ + "media/assets/images/tour/full_daybook-78b5cc9c0523b0e137591312fca1e9cc.jpg";